var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#2D54E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 21.3333H21.8334C20.3667 21.3333 19.1801 22.5333 19.1801 23.9999L19.1667 39.9999C19.1667 41.4666 20.3667 42.6666 21.8334 42.6666H32.5001V39.9999H21.8334V26.6666L32.5001 33.3333L43.1667 26.6666V33.3333H45.8334V23.9999C45.8334 22.5333 44.6334 21.3333 43.1667 21.3333ZM32.5001 30.6666L21.8334 23.9999H43.1667L32.5001 30.6666ZM39.6201 45.3333L34.9001 40.6133L36.7801 38.7333L39.6067 41.5599L45.2601 35.9066L47.1667 37.7866L39.6201 45.3333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.c4a1d3a726e9ec18614b816ea6467dc9.svg";
export { ForwardRef as ReactComponent };